import angular from 'angular';

module.exports = angular.module('common.filters.trimmed-number', [])
.filter('trimmedNumber', function(numberFilter) {
  return function(num, fractionSize) {
    if (num === undefined || num === null || num === '' || num === Infinity)
      return numberFilter(num);

    num = num.toFixed(fractionSize);

    if (num.indexOf('.') !== -1)
      num = num.replace(/\.?0+$/, "");

    if (num === '-0')
      num = '0';

    return num;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/trimmed-number.js
 **/